import { createApp, h, reactive } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import AppWrapper from './AppWrapper.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import PrimeVue from 'primevue/config'
import AutoComplete from 'primevue/autocomplete'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
import AvatarGroup from 'primevue/avatargroup'
import Badge from 'primevue/badge'
import BadgeDirective from 'primevue/badgedirective'
import BlockUI from 'primevue/blockui'
import Button from 'primevue/button'
import Breadcrumb from 'primevue/breadcrumb'
import Calendar from 'primevue/calendar'
import Card from 'primevue/card'
import CascadeSelect from 'primevue/cascadeselect'
import Carousel from 'primevue/carousel'
import Chart from 'primevue/chart'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import Chips from 'primevue/chips'
import ColorPicker from 'primevue/colorpicker'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmPopup from 'primevue/confirmpopup'
import ConfirmationService from 'primevue/confirmationservice'
import ContextMenu from 'primevue/contextmenu'
import DataTable from 'primevue/datatable'
import DataView from 'primevue/dataview'
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import Fieldset from 'primevue/fieldset'
import FileUpload from 'primevue/fileupload'
import FullCalendar from 'primevue/fullcalendar'
import Image from 'primevue/image'
import Galleria from 'primevue/galleria'
import InlineMessage from 'primevue/inlinemessage'
import Inplace from 'primevue/inplace'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
import Knob from 'primevue/knob'
import Listbox from 'primevue/listbox'
import MegaMenu from 'primevue/megamenu'
import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import Message from 'primevue/message'
import Editor from 'primevue/editor'
import MultiSelect from 'primevue/multiselect'
import OrderList from 'primevue/orderlist'
import OrganizationChart from 'primevue/organizationchart'
import OverlayPanel from 'primevue/overlaypanel'
import Paginator from 'primevue/paginator'
import Panel from 'primevue/panel'
import PanelMenu from 'primevue/panelmenu'
import Password from 'primevue/password'
import PickList from 'primevue/picklist'
import ProgressBar from 'primevue/progressbar'
import Rating from 'primevue/rating'
import RadioButton from 'primevue/radiobutton'
import Ripple from 'primevue/ripple'
import Row from 'primevue/row'
import SelectButton from 'primevue/selectbutton'
import ScrollPanel from 'primevue/scrollpanel'
import ScrollTop from 'primevue/scrolltop'
import Skeleton from 'primevue/skeleton'
import Slider from 'primevue/slider'
import Sidebar from 'primevue/sidebar'
import SplitButton from 'primevue/splitbutton'
import Splitter from 'primevue/splitter'
import SplitterPanel from 'primevue/splitterpanel'
import Steps from 'primevue/steps'
import TabMenu from 'primevue/tabmenu'
import TieredMenu from 'primevue/tieredmenu'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Toolbar from 'primevue/toolbar'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Tag from 'primevue/tag'
import Timeline from 'primevue/timeline'
import ToggleButton from 'primevue/togglebutton'
import Tooltip from 'primevue/tooltip'
import Tree from 'primevue/tree'
import TreeTable from 'primevue/treetable'
import TriStateCheckbox from 'primevue/tristatecheckbox'
import CodeHighlight from './AppCodeHighlight'
import VueCountdown from '@chenfengyuan/vue-countdown'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import ProgressSpinner from 'primevue/progressspinner'
import '@fullcalendar/daygrid/main.min.css'
import '@fullcalendar/timegrid/main.min.css'
import 'prismjs/themes/prism-coy.css'
import i18n, { messages } from './i18n'
import CButton from './components/CButton.vue'
import { modelConfig } from './api/Services'

import 'bootstrap/dist/css/bootstrap.min.css'
import { FontAwesomeIcon } from './plugins/font-awesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faSnowflake } from '@fortawesome/free-regular-svg-icons'
import { getItem, setItem } from './store/localStorage'
import { apiURL } from './api/api_var'
// import GAuth from 'vue3-google-oauth2'

import vue3GoogleLogin from 'vue3-google-login'
import rate from 'vue-rate'
import 'vue-rate/dist/vue-rate.css'
// import { VueRecaptchaPlugin  } from 'vue-recaptcha';
// import { useChallengeV3 } from 'vue-recaptcha/challenge-v3'
//  import { useChallengeV3 } from "vue-recaptcha-v3";
// import {VueGrecaptcha} from vue-grecaptcha
// import VueRecaptcha from 'vue-recaptcha';
// import VueRecaptcha from 'vue-recaptcha';

// import vue3GoogleLogin from "vue3-google-login";
// import rate from "vue-rate";
// import "vue-rate/dist/vue-rate.css";

const gAuthOptions = {
  clientId:
    '507090213344-8v0tj6ahma957ch491hb6pqgjbb2da2b.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
  plugin_name: 'CrowdHRs',
  
}

const app = createApp(AppWrapper)
window.t = i18n.t

window.App = app
app.use(i18n)
let localeLang = getItem('locale')

if (localeLang == 'tr') {
  setItem('locale', 'en')
  localeLang = 'en'
}
library.add(faUserSecret, faSnowflake)

// app.use(PrimeVue, {
//   ripple: true,
//   locale: localeLang == 'tr' ? messages.tr : messages.en,accept: 'Aceptar',
//   reject: 'Rechazar',
// });

// app.use(PrimeVue, {
//   ripple: true,
//   locale: {
//       accept: 'Aceptar',
//       reject: 'Rechazar',
//        locale:localeLang == 'tr' ? messages.tr : messages.en

//   }
// });
// app.use(VueReCaptcha, {  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,secretKey: process.env.VUE_APP_RECAPTCHA_SECRET_KEY})
// app.use(VueGrecaptcha, {
//   sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
// })
// app.use(VueRecaptchaPlugin, {
//   v2SiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY_V2
// })
app.use(PrimeVue, {
  locale: {
    accept: 'Yes',
    reject: 'No',
    locale: localeLang == 'tr' ? messages.tr : messages.en,
    dayNames: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: 'Today',
    weekHeader: 'Wk',
    firstDayOfWeek: 0,
    dateFormat: 'mm/dd/yy',
  },
})
// app.use(GAuth, gAuthOptions)
app.use(vue3GoogleLogin, {
  clientId: '507090213344-8v0tj6ahma957ch491hb6pqgjbb2da2b.apps.googleusercontent.com',
})
// app.use(vue3GoogleLogin, {
//   clientId:
//     "472906232646-15gbh3aldok115c8ugrldiqeg6pqnuhk.apps.googleusercontent.com",
//   // scope: 'email',
//   // prompt: 'consent',
//   // plugin_name: 'CrowdHR',
//   // fetch_basic_profile: false,
// });
app.use(store)
app.use(ConfirmationService)
app.use(ToastService)
app.use(rate)
app.component(VueCountdown.name, VueCountdown)
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(router)
modelConfig.store = store

app.config.globalProperties.$appState = reactive({
  inputStyle: 'filled',
  RTL: false,
  isNewThemeLoaded: false,
  layoutMode: 'light',
  API_URL: apiURL,
})

app.directive('tooltip', Tooltip)
app.directive('badge', BadgeDirective)
app.directive('ripple', Ripple)
app.directive('code', CodeHighlight)
// app.component('vue-recaptcha', VueRecaptcha);
app.component('Accordion', Accordion)
app.component('AccordionTab', AccordionTab)
app.component('AutoComplete', AutoComplete)
app.component('Avatar', Avatar)
app.component('AvatarGroup', AvatarGroup)
app.component('Badge', Badge)
app.component('BlockUI', BlockUI)
app.component('Breadcrumb', Breadcrumb)
app.component('Button', Button)
app.component('Calendar', Calendar)
app.component('Card', Card)
app.component('Carousel', Carousel)
app.component('CascadeSelect', CascadeSelect)
app.component('Chart', Chart)
app.component('Checkbox', Checkbox)
app.component('Chip', Chip)
app.component('Chips', Chips)
app.component('ColorPicker', ColorPicker)
app.component('Column', Column)
app.component('ColumnGroup', ColumnGroup)
app.component('ConfirmDialog', ConfirmDialog)
app.component('ConfirmPopup', ConfirmPopup)
app.component('ContextMenu', ContextMenu)
app.component('DataTable', DataTable)
app.component('DataView', DataView)
app.component('DataViewLayoutOptions', DataViewLayoutOptions)
app.component('Dialog', Dialog)
app.component('Divider', Divider)
app.component('Dropdown', Dropdown)
app.component('Fieldset', Fieldset)
app.component('FileUpload', FileUpload)
app.component('FullCalendar', FullCalendar)
app.component('InlineMessage', InlineMessage)
app.component('Inplace', Inplace)
app.component('InputMask', InputMask)
app.component('InputNumber', InputNumber)
app.component('InputSwitch', InputSwitch)
app.component('InputText', InputText)
app.component('Galleria', Galleria)
app.component('Image', Image)
app.component('Knob', Knob)
app.component('Listbox', Listbox)
app.component('MegaMenu', MegaMenu)
app.component('Menu', Menu)
app.component('Menubar', Menubar)
app.component('Message', Message)
app.component('MultiSelect', MultiSelect)
app.component('OrderList', OrderList)
app.component('OrganizationChart', OrganizationChart)
app.component('OverlayPanel', OverlayPanel)
app.component('Paginator', Paginator)
app.component('Panel', Panel)
app.component('PanelMenu', PanelMenu)
app.component('Password', Password)
app.component('PickList', PickList)
app.component('ProgressBar', ProgressBar)
app.component('RadioButton', RadioButton)
app.component('Rating', Rating)
app.component('Row', Row)
app.component('SelectButton', SelectButton)
app.component('ScrollPanel', ScrollPanel)
app.component('ScrollTop', ScrollTop)
app.component('Slider', Slider)
app.component('Sidebar', Sidebar)
app.component('Skeleton', Skeleton)
app.component('SplitButton', SplitButton)
app.component('Splitter', Splitter)
app.component('SplitterPanel', SplitterPanel)
app.component('Steps', Steps)
app.component('TabMenu', TabMenu)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('Tag', Tag)
app.component('Textarea', Textarea)
app.component('TieredMenu', TieredMenu)
app.component('Timeline', Timeline)
app.component('Toast', Toast)
app.component('Toolbar', Toolbar)
app.component('ToggleButton', ToggleButton)
app.component('Tree', Tree)
app.component('TreeTable', TreeTable)
app.component('TriStateCheckbox', TriStateCheckbox)
app.component('Editor', Editor)
app.component('fa', FontAwesomeIcon)
app.component('ProgressSpinner', ProgressSpinner)
app.component('CButton', CButton)
app.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY_V3,
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: false
  }
})
app.mount('#app')
